var jade = require("/var/lib/jenkins/workspace/rel_build_mdm/frontend/client/node_modules/jade/lib/runtime.js");

module.exports = function template(locals) {
var buf = [];
var jade_mixins = {};
var jade_interp;

buf.push("<div vueinit props=\"{ createProjektbericht: vm.createProjektbericht }\"><vue-projektbericht-list v-bind:create-projektbericht=\"propsAngular.createProjektbericht\"></vue-projektbericht-list></div>");;return buf.join("");
}